import YurtSVG from "../../../../YurtSVG";
import styled from "styled-components";
import moment from "moment";
import { Trash } from "phosphor-react";
import { categorySort } from "../../calculations";

const Container = styled.div`
  background: white;
  padding: 20px;
  svg {
    display: none;
    position: absolute;
    left: 20px;
    top: 20px;
    width: 3rem;
  }

  h1,
  h2 {
    color: black;
    margin: 40px;
    text-align: center;
  }
  @media print {
    svg {
      display: block;
    }
  }
`;

const Button = styled.div`
  right: 0;
  border: 1px solid black;
  cursor: pointer;
  color: black;
  width: max-content;
  padding: 5px;
  border-radius: 3px;
  &:hover {
    background: black;
    color: white;
  }
  svg {
    display: block;
    position: relative;
    left: unset;
    top: unset;
    width: unset;
  }
  @media print {
    display: none;
  }
`;

const Title = styled.div`
  color: black;
  font-size: 2rem;
  font-weight: 900;
  small {
    font-size: 1rem;
  }
  @media print {
    padding-top: 60px;
  }
`;

const Dates = styled.div`
  color: grey;
`;

const Notes = styled.div`
  border: 1px solid lightgrey;
  padding: 5px 10px;
  margin: 10px 0;
  border-radius: 3px;
`;

const Created = styled.div`
  color: lightgrey;
  font-size: 0.75rem;
`;

const TableElements = styled.div`
  input {
    text-transform: capitalize;

    text-decoration: ${({ remove }) => (remove ? "line-through" : "none")};
  }

  display: flex;
  width: 100%;

  @media print {
    display: ${({ remove }) => (remove ? "none" : "flex")};
  }
`;

const Element = styled.div`
  width: 18%;
  border-top: 1px solid rgb(240, 240, 240);
  overflow-wrap: break-word;
  input {
    overflow-wrap: break-word;
    overflow: hidden;
    width: 100%;
  }
`;

const ButtonElement = styled.div`
  width: 3%;
`;

const ItemInput = styled.input`
  border: 1px solid ${({ w }) => (w ? "white" : "grey")};
  border-radius: 3px;
  background: white;
  color: black;
  padding: 5px 0;
  min-width: 30px;
  max-width: ${({ w }) => w + 1}ch;
  text-align: left;
  transition: 0.2s all ease;
  outline: none !important;
  text-transform: capitalize;
  &:focus {
    border: 1px solid lightgrey;
    padding-left: 1px;
  }
`;

const AddItem = styled.div`
  background: black;
  color: white;
  border: 1px solid black;
  width: max-content;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;
  &:hover {
    background: white;
    color: black;
  }
  @media print {
    display: none;
  }
`;

const TableHolder = styled.div``;

const Category = styled.div`
  text-transform: uppercase;

  margin-top: 20px;
  font-weight: 900;
  font-size: 1.1em;
  color: black;
`;

const Table = styled.div`
  width: 100%;
`;

const TableHeader = styled.div`
  display: flex;
  width: 100%;
  color: lightgrey;
  padding: 10px 0;
  font-weight: 900;
`;

const HeaderItem = styled.div`
  width: 18%;
`;

function WoodPrint({
  yurtTrait,
  walls,
  date,
  notes,
  materials,
  setSpecificCustom,
  setSpecificDefault,
  addItem,
  removeMaterial,
}) {
  const categories =
    typeof materials !== "undefined" ? categorySort(materials) : 0;
  return (
    <Container>
      <YurtSVG width="2rem" />
      <Title>
        {yurtTrait.kitName} <small>Materials Order</small>
      </Title>
      <Dates>
        <div>
          Needed: <b>{moment(date).format("ddd, MMM D, YYYY")}</b>
        </div>
        <Created>
          Created: <b>{moment().format("ddd, MMM D, YYYY")}</b>
        </Created>
        {notes ? <Notes>{notes}</Notes> : <></>}
      </Dates>
      {typeof materials === "undefined" ? null : (
        <TableHolder>
          {categories.map((cat, k) => (
            <div key={k}>
              <Category>{cat}</Category>
              <Table>
                <TableHeader>
                  <HeaderItem>Type</HeaderItem>
                  <HeaderItem>Board</HeaderItem>
                  <HeaderItem>Length</HeaderItem>
                  <HeaderItem>Amount</HeaderItem>
                  <HeaderItem>Purpose</HeaderItem>
                </TableHeader>

                {materials
                  .filter((e) => e.category === cat)
                  .map((material, index) =>
                    material.amount ? (
                      <TableElements remove={material.remove} key={material.id}>
                        <Element>
                          <ItemInput
                            id="type"
                            defaultValue={material.type}
                            key={material.type}
                            onBlur={(e) => setSpecificCustom(e, material.id)}
                            w={material.type.length}
                          ></ItemInput>
                        </Element>
                        <Element>
                          <ItemInput
                            id="board"
                            defaultValue={material.board}
                            key={material.board}
                            onBlur={(e) => setSpecificCustom(e, material.id)}
                            w={material.board.length}
                          ></ItemInput>
                        </Element>
                        <Element>
                          <ItemInput
                            id="length"
                            defaultValue={material.length}
                            key={material.length}
                            onBlur={(e) => setSpecificCustom(e, material.id)}
                            w={material.length.length}
                          ></ItemInput>
                        </Element>
                        <Element>
                          <ItemInput
                            id="amount"
                            defaultValue={material.amount}
                            key={material.amount}
                            onBlur={(e) => setSpecificCustom(e, material.id)}
                            w={material.amount.toString().length}
                          ></ItemInput>
                        </Element>
                        <Element>
                          <ItemInput
                            id="purpose"
                            defaultValue={material.purpose}
                            onBlur={(e) => setSpecificCustom(e, material.id)}
                            w={material.purpose.length}
                          ></ItemInput>
                        </Element>
                        <ButtonElement>
                          <Button
                            onClick={() =>
                              removeMaterial(material, material.id)
                            }
                          >
                            <Trash size={10} />
                          </Button>
                        </ButtonElement>
                      </TableElements>
                    ) : (
                      <></>
                    )
                  )}
              </Table>
            </div>
          ))}
        </TableHolder>
      )}

      <AddItem onClick={() => addItem()}>+</AddItem>
    </Container>
  );
}

export default WoodPrint;
